<script setup>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import CourseHeader from "@/components/Dashboard/Courses/Course/core/CourseHeader.vue";
import AddCourse from "@/components/Dashboard/Courses/Course/core/AddCourse.vue";
import CourseTable from "@/components/Dashboard/Courses/Course/core/CourseTable.vue";
import AssociatesSection from "./AssociatesSection.vue";
import CourseDetailTabs from "@/components/Dashboard/Courses/Course/core/CourseDetailTabs.vue";

const store = useStore();
const route = useRoute();

const courseId = route.params.id;

const course = computed(() => store.getters["course/getCourse"]);
const isLoading = computed(() => store.getters["course/isLoadingCourse"]);

onMounted(async () => {
  await store.dispatch("course/fetchCourse", courseId);
});

const isCourseSetupComplete = computed(() => {
  if (!course.value) {
    return false;
  }
  return course.value.setup_complete === 1;
});
</script>

<template>
  <template v-if="!isLoading && course">
    <CourseHeader :name="course.name" />
    <section class="content">
      <div class="row">
        <AddCourse v-if="!isCourseSetupComplete" :courseId="courseId" />
        <CourseTable />
        <AssociatesSection :course="course" />
        <CourseDetailTabs />
      </div>
    </section>
  </template>
</template>
